import { LOG_LEVEL, LOG_API_URL, APPINSIGHTS_KEY, DATADOG_CLIENT_TOKEN } from '../config';
import consoleAdapter from './adapters/consoleAdapter';
import apiAdapter from './adapters/apiAdapter';
import appInsightsAdapter from './adapters/appInsightsAdapter';
import datadogAdapter from './adapters/datadogAdapter';

const LOG_LEVELS = {
  debug: 1,
  info: 2,
  warn: 3,
  error: 4,
  transaction: 5, // Tracing important business actions regardless of general LOG_LEVEL
};

class Logger {
  constructor() {
    this.adapters = [];
    this.currentLevel = LOG_LEVELS[LOG_LEVEL?.toLowerCase()] || LOG_LEVELS.info;

    this.initAdapters();
  }

  initAdapters() {
    // 1. Sempre registra o ConsoleAdapter para desenvolvimento/debugging
    // Em produção ele pode apenas logar error e transaction silenciosamente
    this.adapters.push(consoleAdapter);

    // 2. Se a URL da API estiver preenchida, usamos o conector API para guardar
    if (LOG_API_URL) {
      this.adapters.push(apiAdapter);
    }

    // 3. Se chaves de telemetria baseadas em agent estiverem ali, usamos elas
    if (APPINSIGHTS_KEY) {
      this.adapters.push(appInsightsAdapter);
    }

    if (DATADOG_CLIENT_TOKEN) {
      this.adapters.push(datadogAdapter);
    }
  }

  _log(levelName, message, data) {
    const levelValue = LOG_LEVELS[levelName];
    
    // Filtro por severidade (exceção feita para transactions que tentamos sempre registrar)
    if (levelValue < this.currentLevel && levelName !== 'transaction') {
      return;
    }

    const payload = {
      timestamp: new Date().toISOString(),
      level: levelName.toUpperCase(),
      message,
      data,
    };

    this.adapters.forEach((adapter) => {
      try {
        adapter.log(payload);
      } catch (err) {
        // Fallback robusto caso um adapter quebre (não usamos o próprio logger para evitar infinite loops)
        console.error(`[LOGGER] Adapter ${adapter.name} failed to process log:`, err);
      }
    });
  }

  debug(message, data = null) {
    this._log('debug', message, data);
  }

  info(message, data = null) {
    this._log('info', message, data);
  }

  warn(message, data = null) {
    this._log('warn', message, data);
  }

  error(message, errorOrData = null) {
    this._log('error', message, errorOrData);
  }

  transaction(message, data = null) {
    this._log('transaction', message, data);
  }
}

export const logger = new Logger();
